"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurExperiences() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const experiences = [{
    title: "Pass the Plate",
    description: "Join our monthly supper club for an intimate dining experience with curated menus that change every month. Connect with fellow food lovers and create community through shared culinary moments.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1509250/img/pass_the_plate_dinner.png",
    linkTo: "#"
  }, {
    title: "Create the Plate",
    description: "Learn hands-on cooking techniques in small, personalized classes. We demystify cooking and make it approachable, fun, and memorable with step-by-step guidance from Chef Jess.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1509250/img/create_the_plate_class.png",
    linkTo: "#"
  }];
  return <section id="our-experiences" className="bg-background py-16 px-6 md:py-24 md:px-12">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground text-center mb-12">
          Our Experiences
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {experiences.map((exp, i) => {
          const isCard1 = i === 0;
          const cardRef = isCard1 ? card1Ref : card2Ref;
          const cardVisible = isCard1 ? card1Visible : card2Visible;
          return <div key={i} data-index={i} ref={cardRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <Card className="group overflow-hidden h-full flex flex-col transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-strong">
                  <div className="relative h-64 overflow-hidden">
                    <img src={exp.image} alt={exp.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]" />
                  </div>
                  <CardContent className="flex-1 flex flex-col gap-4 py-6">
                    <h3 className="font-display text-2xl font-semibold text-foreground">
                      {exp.title}
                    </h3>
                    <p className="text-muted-foreground text-base leading-relaxed flex-1">
                      {exp.description}
                    </p>
                    <div className="mt-2">
                      <Button asChild className="transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] group-hover:scale-105 group-hover:shadow-medium">
                        <Link to={exp.linkTo}>Learn More</Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}